import { render, staticRenderFns } from "./CabeceraObjetivo.vue?vue&type=template&id=1acf2def&scoped=true&"
import script from "./CabeceraObjetivo.vue?vue&type=script&lang=js&"
export * from "./CabeceraObjetivo.vue?vue&type=script&lang=js&"
import style0 from "./CabeceraObjetivo.vue?vue&type=style&index=0&id=1acf2def&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acf2def",
  null
  
)

export default component.exports